import React from "react";

function TandC() {
  const emailUser = "contact";
  const emailDomain = "pixelcreator";
  const emailTld = "co.uk";
  const email = `${emailUser}@${emailDomain}.${emailTld}`;

  const handleEmailClick = () => {
    window.location.href = `mailto:${email}`;
  };

  const linkBtn = {
    background: "none",
    border: "none",
    color: "#0b57d0",
    textDecoration: "underline",
    cursor: "pointer",
    padding: 0,
    font: "inherit",
  };

  return (
    <div style={{ backgroundColor: "#3b3b3b", lineHeight: 1.6 }}>
      <header
        style={{
          backgroundColor: "#3b3b3b",
          color: "#FFF9DB",
          padding: "2rem 1rem",
          textAlign: "center",
        }}
      >
        <h1>Terms and Conditions</h1>
      </header>

      <main
        style={{
          maxWidth: "900px",
          margin: "0.5rem auto",
          background: "#FFFAEF",
          padding: "2.5rem",
          borderRadius: "12px",
          boxShadow: "0 2px 10px rgba(0, 0, 0, 0.1)",
          color: "#1c1c1c",
        }}
      >
        <p>
          <strong>Business Name:</strong> Pixel Creator
        </p>
        <p>
          <strong>Website:</strong> www.pixelcreator.co.uk
        </p>
        <p>
          <strong>Contact Email:</strong>{" "}
          <button
            type="button"
            onClick={handleEmailClick}
            style={linkBtn}
            aria-label={`Email ${email}`}
          >
            {email}
          </button>
        </p>

        <h2>1. Introduction</h2>
        <p>
          These Terms and Conditions apply to all website design, development,
          hosting, and related services provided by <strong>Pixel Creator</strong> (“we”, “us”, or “our”) to the client
          (“you” or “your”). By requesting or purchasing our services, you agree
          to be bound by these Terms and Conditions.
        </p>

        <h2>2. Services Provided</h2>
        <p>Pixel Creator offers:</p>
        <ul>
          <li>Website design and development</li>
          <li>Branding, logo, and graphic design</li>
          <li>Hosting, maintenance, and domain management</li>
          <li>Optional ongoing support and updates</li>
        </ul>
        <p>
          The exact scope of work, pricing, and timescales will be outlined in
          your written quotation or project proposal.
        </p>

        <h2>3. Quotations and Payments</h2>
        <ul>
          <li>
            All quotations are valid for <strong>30 days</strong> from the date
            of issue.
          </li>
          <li>
            A <strong>50% deposit</strong> is required before work begins,
            unless otherwise agreed in writing.
          </li>
          <li>
            The <strong>remaining 50%</strong> is due upon completion and before
            the website goes live.
          </li>
          <li>Payment is accepted by bank transfer or other agreed methods.</li>
          <li>
            Invoices must be paid within <strong>7 days</strong> of issue.
          </li>
          <li>
            Late payments may incur interest at{" "}
            <strong>4% above the Bank of England base rate</strong>.
          </li>
        </ul>

        <h2>4. Client Responsibilities</h2>
        <p>You agree to:</p>
        <ul>
          <li>
            Provide all required content (text, images, and other materials)
            promptly.
          </li>
          <li>
            Ensure you own or have permission to use any materials supplied.
          </li>
          <li>
            Review and approve drafts or designs in a timely manner to prevent
            delays.
          </li>
        </ul>
        <p>Delays in providing materials or feedback may extend project timelines.</p>

        <h2>5. Revisions and Changes</h2>
        <p>
          Each project includes a reasonable number of design revisions as
          stated in your quotation. Additional revisions or changes beyond the
          agreed scope may be charged at an hourly rate agreed in advance.
        </p>

        <h2>6. Ownership and Copyright</h2>
        <ul>
          <li>
            All design work, source code, and related files remain the property
            of Pixel Creator until full payment has been received.
          </li>
          <li>
            Once payment is made in full, ownership of the completed website
            design and associated files transfers to you.
          </li>
          <li>
            Any third-party materials (such as fonts, stock images, or plugins)
            remain subject to their own licences.
          </li>
          <li>
            We reserve the right to display completed projects and designs in
            our portfolio or promotional materials unless you request otherwise
            in writing.
          </li>
        </ul>

        <h2>7. Hosting and Domain Services</h2>
        <ul>
          <li>
            Hosting and domain management may be provided as an ongoing service,
            billed monthly or annually.
          </li>
          <li>
            Hosting fees cover routine maintenance, storage, and bandwidth as
            specified in your agreement.
          </li>
          <li>
            You are responsible for renewing hosting and domain services on time to avoid service interruption. 
            We will endeavour to notify you of upcoming renewal dates, but we cannot guarantee delivery of such reminders.
          </li>
          <li>
            We are not liable for downtime, data loss, or disruptions caused by
            third-party providers or factors beyond our control.
          </li>
        </ul>

        <h2>8. Cancellation and Refunds</h2>
        <ul>
          <li>
            If you cancel the project before completion, the deposit is{" "}
            <strong>non-refundable</strong>.
          </li>
          <li>
            If significant work has been completed, an additional payment may be
            required based on the proportion of work completed.
          </li>
          <li>
            We reserve the right to cancel a project if a client becomes
            unresponsive or fails to make payment within a reasonable timeframe.
          </li>
        </ul>

        <h2>9. Liability</h2>
        <p>
          While every effort is made to ensure your website functions correctly
          and securely, we cannot be held responsible for:
        </p>
        <ul>
          <li>Software errors, bugs, or third-party issues</li>
          <li>Downtime or data loss resulting from hosting or external factors</li>
          <li>Indirect or consequential losses arising from use of your website</li>
        </ul>
        <p>
          Our total liability shall not exceed the total amount paid for the
          project.
        </p>

        <h2>10. SEO, Performance, and Third-Party Tools</h2>
        <p>
          We follow best practices for performance and basic search engine
          optimisation (SEO), but we cannot guarantee specific search rankings,
          visitor numbers, or results. Third-party plugins, analytics, or
          integrations may be subject to their own terms and are used at your
          discretion.
        </p>

        <h2>11. Confidentiality</h2>
        <p>
          All client information and materials are treated as confidential and
          will not be shared with third parties without consent, except where
          required by law.
        </p>

        <h2>12. Governing Law</h2>
        <p>
          These Terms and Conditions are governed by and interpreted in
          accordance with the laws of <strong>England and Wales</strong>. Any
          disputes will be handled by the courts of England and Wales.
        </p>

        <h2>13. Acceptance</h2>
        <p>
          By paying a deposit, signing a proposal, or confirming your order in
          writing, you confirm that you have read, understood, and agreed to
          these Terms and Conditions.
        </p>

        <h2>14. Contact</h2>
        <p>For any questions about these Terms and Conditions, please contact:</p>
        <ul>
          <li>
            <strong>Email:</strong>{" "}
            <button
              type="button"
              onClick={handleEmailClick}
              style={linkBtn}
              aria-label={`Email ${email}`}
            >
              {email}
            </button>
          </li>
          <li>
            <strong>Website:</strong> www.pixelcreator.co.uk
          </li>
        </ul>
      </main>

      <p
        style={{
          backgroundColor: "#3b3b3b",
          color: "#FFF9DB",
          textAlign: "center",
        }}
      >
        Last Updated: 01 November 2025
      </p>
    </div>
  );
}

export default TandC;

